<template>
  <grid-row>
    <grid-column :size="10">
      <form-field-collection
        label="Attach Tags"
        v-model="tagsToAdd"
        :options="availableTags"
        field="label"
        placeholder="Select tags"
        icon="label"
        @change="handleInput"
        :validation-errors="validationErrors.tagsToAdd"
      />
    </grid-column>
  </grid-row>
</template>

<script>
import utils from "../../../../services/utils";

export default {
  name: 'StatusAddContactTagAutomation',
  props: {
    selectedTags: Array,
    validationErrors: {},
  },
  data() {
    return {
      tagsToAdd: []
    }
  },
  mounted() {
    this.handleMount()
  },
  computed: {
    availableTags() {
      return this.$store.getters.contactTags
    },
  },
  methods: {
    handleMount() {
      this.tagsToAdd = utils.clone(this.selectedTags)
    },
    handleInput() {
      this.$emit('setTags', this.tagsToAdd);
    },
  }
}
</script>

<style scoped lang="scss">

</style>
